import React from 'react'
import TopBanner from '../components/common/TopBanner'
import Moto from '../components/common/Moto'
import Service from '../components/common/Service'


const LandingPage = () => {
   
   return (
     <div>
       <TopBanner/>
       <Service/>
       <Moto/>
    </div>
  )
}

export default LandingPage